import Box from "@material-ui/core/Box/Box";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import React, { ChangeEvent } from "react";
import ActionTemplate from "../../../api/models/test-series/ActionTemplate";
import CustomDropdown from "../../Input/CustomDropdown";

export interface ActionTemplateDropdownProps {
  selectedTemplate: string;
  templates: ActionTemplate[];
  handleChange: (e: ChangeEvent<{ name?: string; value: unknown }>) => void;
}

const ActionTemplateDropdown: React.FC<ActionTemplateDropdownProps> = (props: ActionTemplateDropdownProps) => {
  const { selectedTemplate, templates, handleChange } = props;

  return (
    <Box pb={4}>
      <CustomDropdown
        labelText="Choose template"
        onChange={handleChange}
        value={selectedTemplate}
        name={selectedTemplate}
      >
        {templates?.map((t) => (
          <MenuItem key={t.id} value={t.name}>
            {t.name}
          </MenuItem>
        ))}
      </CustomDropdown>
    </Box>
  );
};

export default ActionTemplateDropdown;
